import { LazyAction, LazyModule } from 'owa-bundling';
import type { OcsSettingScope, OcsVersion } from './common';
import type { OcsRequestOptions } from './common';
import type { OcsPatchEntry } from './writeOcsSettings';

export {
    makeOcsBaseUrl,
    makeOcsRequestUrl,
    OcsSettingScope,
    OcsSettingType,
    OcsVersion,
} from './common';
export type { OcsRequestOptions } from './common';
export type { OcsPatchEntry } from './writeOcsSettings';

// If anyone wants the lazy action for these functions, here they are.
const lazyModule = new LazyModule(() => import(/* webpackChunkName: "OcsService" */ './lazyIndex'));
export const lazyReadOcsSettings = new LazyAction(lazyModule, m => m.readOcsSettings);
export const lazyWriteOcsSettings = new LazyAction(lazyModule, m => m.writeOcsSettings);

// But here are convenience wrappers that move the lazy load inside the promise chain.
export function readOcsSettings(
    version: OcsVersion,
    scope: OcsSettingScope,
    settings: string[],
    options?: OcsRequestOptions
) {
    return lazyReadOcsSettings.importAndExecute(version, scope, settings, options);
}
export function writeOcsSettings(
    version: OcsVersion,
    scope: OcsSettingScope,
    patches: OcsPatchEntry[],
    options?: OcsRequestOptions
) {
    return lazyWriteOcsSettings.importAndExecute(version, scope, patches, options);
}
